"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Styled = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _templateObject, _templateObject2;

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var Styled = {
  SVG: _styledComponents.default.svg(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    ", ";\n  "])), function (_ref) {
    var fill = _ref.fill;
    return fill && "fill: ".concat(fill);
  }),
  Image: _styledComponents.default.img(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    width: ", ";\n    display: inline-block;\n    ", "\n  "])), function (_ref2) {
    var _ref2$width = _ref2.width,
        width = _ref2$width === void 0 ? '100%' : _ref2$width;
    return width;
  }, function (_ref3) {
    var fill = _ref3.fill;
    return ['#FFF', '#FFFFFF', 'white'].findIndex(function (i) {
      return i === fill;
    }) > -1 && 'filter: invert(1);';
  })
};
exports.Styled = Styled;
var _default = Styled;
exports.default = _default;